export const FLYBUYS_NUMBER_LENGTH = 16;
export const FLYBUYS_PREFIX = '600894';

export const validateFlybuysNumber = (flybuysNum: string) => {
  // Code provided by IAG, modified slightly to pass lint rules
  let isValid = flybuysNum.length === FLYBUYS_NUMBER_LENGTH;
  if (isValid) {
    let sum = 0;
    let alternate = false;
    for (let i = flybuysNum.length - 1; i >= 0; i -= 1) {
      let n = parseInt(flybuysNum.charAt(i), 10);
      if (alternate) {
        n *= 2;
        n = n > 9 ? (n % 10) + 1 : n;
      }
      sum += n;
      alternate = !alternate;
    }
    isValid = sum % 10 === 0;
  }
  return isValid;
};
